<div class="or-p-16-px or-pt-40-px or-bg-shade">
  <div class="or-head-xs or-color-secondary-2 or-mb-12-px">Szczegóły gracza</div>

  <div class="or-d-flex or-align-items-center or-mb-20-px or-justify-content-between">
    <div class="or-d-flex or-align-items-center">
      <lib-or-avatar
        [avatarUrl]="player.userThumbnail"
        [initials]="player.userDisplayName"
        [avatarSize]="'sm'"></lib-or-avatar>

      <div class="or-head-sm or-truncate-at-line-1">{{ player.userDisplayName }}</div>

      <div class="or-d-flex or-align-items-center or-ml-8-px">
        @if (player.playerPreferences?.preferredPosition === 'GOALKEEPER') {
          <or-icon name="gk" size="m" class="or-mr-4-px" />
        }
        @for (penalty of player.penalties; track penalty.userPenaltyId) {
          <img [src]="cardReasonMapper[penalty.penaltyReason!]?.icon" />
        }
      </div>
    </div>

    @if (player.isPaid) {
      <img src="assets/icons/payment-icon.svg" />
    }
  </div>

  @if (isPlayerInGame) {
    <div
      (click)="changePaymentStatus()"
      class="or-cursor-pointer border-radius-4 border-shade or-align-items-center or-bg-white or-mb-8-px or-d-flex or-p-8-px">
      <or-icon name="amount-2" size="s" boxed class="or-mr-8-px" />

      @if (!player.isPaid) {
        <div class="or-text-md">Oznacz jako opłacone</div>
      }
      @if (player.isPaid) {
        <div class="or-text-md">Oznacz jako nieopłacone</div>
      }
    </div>
  }
  @if (!player.isHost && player.userId) {
    @if (revokableComments().length) {
      <div
        (click)="revokeComment()"
        class="or-cursor-pointer border-radius-4 border-shade or-align-items-center or-bg-white or-mb-8-px or-d-flex or-p-8-px or-h-56-px or-max-h-28-px">
        <img src="assets/icons/comment-icon-shade.svg" class="or-mr-8-px or-size-32-px" />
        <div class="or-text-md">Cofnij komplement za tę grę</div>
      </div>
    } @else {
      <div
        (click)="addComment()"
        class="or-cursor-pointer border-radius-4 border-shade or-align-items-center or-bg-white or-mb-8-px or-d-flex or-p-8-px or-h-56-px or-max-h-28-px">
        <img src="assets/icons/comment-icon-shade.svg" class="or-mr-8-px or-size-32-px" />
        <div class="or-text-md">Przyznaj komplement</div>
      </div>
    }
  }
  @if (!player.isHost && player.userId) {
    @if (revokableCard()) {
      <div
        (click)="revokeCard()"
        class="or-cursor-pointer border-radius-4 border-shade or-align-items-center or-bg-white or-mb-8-px or-d-flex or-p-8-px or-h-56-px or-max-h-28-px">
        <img src="assets/icons/shade-card.svg" class="or-mr-8-px or-size-32-px" />
        <div class="or-text-md">Cofnij kartkę za tę grę</div>
      </div>
    } @else {
      <div
        (click)="addCard()"
        class="or-cursor-pointer border-radius-4 border-shade or-align-items-center or-bg-white or-mb-8-px or-d-flex or-p-8-px or-h-56-px or-max-h-28-px">
        <img src="assets/icons/shade-card.svg" class="or-mr-8-px or-size-32-px" />
        <div class="or-text-md">Przyznaj kartkę</div>
      </div>
    }
  }
  @if (!player.userId && isPlayerInGame) {
    <div
      (click)="editPlayer()"
      class="or-cursor-pointer border-radius-4 border-shade or-align-items-center or-bg-white or-mb-8-px or-d-flex or-p-8-px or-h-56-px or-max-h-28-px">
      <or-icon name="edit-profile" size="s" boxed class="or-mr-8-px" />
      <div class="or-text-md">Edytuj gracza</div>
    </div>
  }
  @if (isPlayerInGame) {
    <div
      (click)="removePlayer(player.isPaid!)"
      class="or-cursor-pointer border-radius-4 border-shade or-align-items-center or-bg-white or-d-flex or-p-8-px">
      <or-icon name="trash" size="s" boxed class="or-mr-8-px" />
      <div class="or-text-md or-color-red">Usuń gracza</div>
    </div>
  }
</div>
